export function flowQuestionOptionValue(option) {
    if (option && typeof option === 'object') {
        return option.value ?? option.key ?? option.label ?? '';
    }

    return option ?? '';
}

export function flowQuestionOptionLabel(option) {
    if (option && typeof option === 'object') {
        return option.label ?? option.value ?? option.key ?? '';
    }

    return option ?? '';
}

export function normalizeFlowQuestionSelectOptions(inputValues) {
    if (!Array.isArray(inputValues)) {
        return [];
    }

    return inputValues.map((option) => ({
        value: flowQuestionOptionValue(option),
        label: flowQuestionOptionLabel(option),
    }));
}

export function flowQuestionRequiredRules(item) {
    if (!item?.isRequired) {
        return [];
    }

    if (item.inputType === 'MULTISELECT') {
        return [{
            required: true,
            type: 'array',
            min: 1,
            message: 'Dit veld is verplicht',
        }];
    }

    return [{required: true, message: 'Dit veld is verplicht'}];
}

export function normalizeLoadedFlowQuestions(questions) {
    return (questions || []).map((question) => {
        let value = question.value ?? null;

        if (question.inputType === 'MULTISELECT') {
            if (Array.isArray(value)) {
                // keep array as-is
            } else if (typeof value === 'string' && value !== '') {
                try {
                    const parsed = JSON.parse(value);
                    value = Array.isArray(parsed) ? parsed : [];
                } catch {
                    value = [];
                }
            } else {
                value = [];
            }
        }

        return {
            ...question,
            value,
        };
    });
}
